if (!customElements.get('layer-dot')) {
  class LayerDot extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.dots = Array.from(this.querySelectorAll('.layer-dot__dot'));
      this.rail = Array.from(this.querySelectorAll('.layer-dot__rail-item'));
      this.items = Array.from(this.querySelectorAll('.layer-dot__item'));
      this.triggers = Array.from(this.querySelectorAll('.layer-dot__item-trigger'));
      this.scroller = this.querySelector('.layer-dot__list.swipe-mobile');
      this.activeIndex = null;

      this.onKeydown = this.onKeydown.bind(this);

      this.bind(this.dots);
      this.bind(this.rail);
      this.bind(this.triggers, { fromList: true });

      this.addEventListener('keydown', this.onKeydown);

      // Theme editor: selecting a layer block should reveal the layer being edited.
      this.addEventListener('shopify:block:select', (event) => {
        const index = this.indexOf(event.target);
        if (index !== -1) this.activate(index);
      });

      const defaultIndex = this.dataset.defaultIndex;
      if (defaultIndex !== undefined && defaultIndex !== '') {
        this.activate(parseInt(defaultIndex, 10), { silent: true });
      }
    }

    bind(controls, options) {
      const settings = options || {};
      const hover =
        this.dataset.activation === 'hover' &&
        !settings.fromList &&
        window.matchMedia('(hover: hover) and (pointer: fine)').matches;

      controls.forEach((control) => {
        control.addEventListener('click', (event) => {
          event.preventDefault();
          this.activate(this.indexOf(control), settings);
        });
        if (hover) {
          control.addEventListener('mouseenter', () => this.activate(this.indexOf(control), settings));
        }
      });
    }

    /* A control carries its own index, but a theme-editor event may target an ancestor
       or descendant of it, so walk to the nearest element that has one. */
    indexOf(element) {
      const owner = element && element.closest('[data-index]');
      return owner ? parseInt(owner.dataset.index, 10) : -1;
    }

    activate(index, options) {
      const settings = options || {};
      if (index < 0 || index >= this.items.length) return;

      this.activeIndex = index;

      this.mark(this.dots, index, 'aria-pressed');
      this.mark(this.rail, index, 'aria-pressed');
      this.mark(this.triggers, index, 'aria-pressed');
      this.items.forEach((item, i) => item.classList.toggle('is-active', i === index));

      if (!settings.silent && !settings.fromList) this.revealItem(index);
    }

    mark(controls, index, attribute) {
      controls.forEach((control, i) => {
        control.classList.toggle('is-active', i === index);
        control.setAttribute(attribute, i === index ? 'true' : 'false');
      });
    }

    /* Activating from a dot or the rail should bring the matching entry into the mobile
       scroller, without dragging the page around with it. */
    revealItem(index) {
      const item = this.items[index];
      if (!item || !this.scroller) return;
      if (this.scroller.scrollWidth <= this.scroller.clientWidth) return;

      const scroller = this.scroller.getBoundingClientRect();
      const target = item.getBoundingClientRect();
      const delta = target.left - scroller.left - (scroller.width - target.width) / 2;
      this.scroller.scrollBy({ left: delta, behavior: 'smooth' });
    }

    onKeydown(event) {
      if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;

      const group = this.rail.indexOf(document.activeElement) !== -1 ? this.rail : this.dots;
      const current = group.indexOf(document.activeElement);
      if (current === -1) return;

      event.preventDefault();
      const step = event.key === 'ArrowRight' ? 1 : -1;
      const next = (current + step + group.length) % group.length;
      group[next].focus();
      this.activate(next);
    }
  }

  customElements.define('layer-dot', LayerDot);
}
